import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { IUserInfo } from '@/models/MyAccount/EmployeeInfo';

const userStorageKey = 'UserInfo';

@Module({ namespaced: true, name: 'UserModule'})
export default class UserModule extends VuexModule {

  private currentUser: IUserInfo | null = null;

  @Mutation
  public SET_CURRENT_USER(user: IUserInfo | null): void {
    this.currentUser = user;
    if (user != null) {
      localStorage.setItem(userStorageKey, JSON.stringify(user));
    } else {
      localStorage.removeItem(userStorageKey);
    }
  }

  @Mutation
  public REMOVE_CURRENT_USER(): void {
    this.currentUser = null ;
    localStorage.removeItem(userStorageKey);
  }

  public get getCurrentUser(): IUserInfo | null {    
    let user: IUserInfo = this.currentUser;
    if (user == null) {
      let userString: string = localStorage.getItem(userStorageKey);
      user = userString == null ? null : JSON.parse(userString) as IUserInfo;
    }
    return user;
  }

  @Action({ commit: 'SET_CURRENT_USER', rawError: true})
  public setCurrentUser(user: IUserInfo | null): IUserInfo | null {
    return user;
  }

  @Action({ commit: 'REMOVE_CURRENT_USER', rawError: true})
  public async removeUser(): Promise<any> {
  }

  // WHEN ADDING STATES, ALWAYS INCLUDE THEM HERE FOR RESET
  @Action({ commit: 'REMOVE_CURRENT_USER', rawError: true})
  public async reset(): Promise<any> {
  }
}
